import React from 'react';
import './ManageHolidays.css';
import { Calender } from './Calender/Calender';
import { useTranslation } from 'react-i18next';



const ManageHolidays = ({ employeeIds, loggedInEmployeeId }) => {

    const { t } = useTranslation();

    return (
        <div className='holiday-page-container'>
            <h2 className='pgTitle'>{t("manageHolidays_title")}</h2>

            <Calender employeeId={loggedInEmployeeId} />

        </div>
    );
};

export default ManageHolidays;
